import styled from 'styled-components/macro'
import { EDirection } from 'types/enums/ELanguage'

export const PasswordInputContainer = styled.div`
  width: 100%;
  position: relative;

  &.strength-0 input,
  &.strength-1 input {
    border: 1px solid #cfb700;
  }

  &.strength-2 input {
    border: 1px solid #ffa500;
  }

  &.strength-3 input {
    border: 1px solid #66cc66; /* Good (mid green) */
  }

  &.strength-4 input {
    border: 1px solid #00cc00; /* Strong (strong green) */
  }

  &.error input {
    border: 1px solid #ff0000;
  }
`

export const PasswordStrength = styled.div<{ direction: EDirection }>`
  position: absolute;
  font-size: 12px;
  ${({ direction }) => (direction === EDirection.RTL ? 'left' : 'right')}: 40px;
  top: 35px;
  height: calc(100% - 2px);
  border-radius: 0;
  border: none;
  background: none;
  z-index: 1;

  &.strength-0,
  &.strength-1 {
    color: #cfb700;
  }

  &.strength-2 {
    color: #ffa500;
  }

  &.strength-3 {
    color: #66cc66;
  }

  &.strength-4 {
    color: #00cc00;
  }
`
